import { useEffect, useState } from 'react';
import * as S from './styles'
import Cookies from 'js-cookie';
import Input from 'antd/es/input/Input';
import { useNavigate } from 'react-router-dom';
import { postLogin } from '../../../service/apiAdmin';
import { toast } from 'react-toastify';

export const Login = () => {
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate()
    const loginCookies = Cookies.get('auth');

    useEffect(()=> {
        if(loginCookies) {
            navigate('/admin/home')
        }
    },[])

    useEffect(()=> {
        if(loginCookies) {
            navigate('/admin/home')
        }
    },[])

    async function handleLogin() {
        if(login.trim() === "" || password.trim() === "") {
            toast.error("Preencha todos os campos!")
            return
        }
        try {
            const result = await postLogin({
                usuario: login,
                senha: password
            })
            if(typeof  result.data === 'string') {
                Cookies.set('auth', result.data, { expires: 30 / (24 * 60) });
                navigate('/admin/home')
                window.location.reload()
            } else {
                toast.error("Login ou senha incorretos!")
                Cookies.set('auth', 'false');
            }
        } catch(error) {
            toast.error("Login ou senha incorretos!")
            Cookies.set('auth', 'false');
        }
      }

    return (
        <S.Container>
            <div>
                <h2>Login</h2>
                <Input style={{backgroundColor: "#f0eeee"}} onChange={(e) => {setLogin(e.target.value)}} placeholder='Usuario' />
                <Input type='password' onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                        handleLogin();
                      }
                }} style={{backgroundColor: "#f0eeee"}} onChange={(e) => {setPassword(e.target.value)}} placeholder='Senha' />
                <button onClick={() => {handleLogin()}} type='button' style={{backgroundColor: "green"}}>Entrar</button>
            </div>
        </S.Container>
    )
}